/* ── FOOD THERAPY THEME JS ── */
(function(){
'use strict';

/* ── UTILS ── */
function qs(sel,ctx){return(ctx||document).querySelector(sel)}
function qsa(sel,ctx){return[...(ctx||document).querySelectorAll(sel)]}
function on(el,ev,fn,opts){if(el)el.addEventListener(ev,fn,opts)}
function money(cents){return'$'+(cents/100).toFixed(2)}

/* ── HEADER SCROLL ── */
const hdr=qs('#site-header');
if(hdr){
  on(window,'scroll',()=>hdr.classList.toggle('scrolled',scrollY>40),{passive:true});
}

/* ── REVEAL ON SCROLL ── */
const reveals=qsa('[data-reveal]');
if(reveals.length){
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(!e.isIntersecting)return;
      const d=+(e.target.dataset.revealDelay||0);
      setTimeout(()=>e.target.classList.add('on'),d);
      io.unobserve(e.target);
    });
  },{threshold:.1});
  reveals.forEach(el=>io.observe(el));
}

/* ── OVERLAY HELPER ── */
const overlay=qs('#overlay');
function showOverlay(){overlay&&overlay.classList.add('open')}
function hideOverlay(){overlay&&overlay.classList.remove('open')}

/* ── MOBILE NAV ── */
const menuToggle=qs('#menu-toggle');
const mobileNav=qs('#mobile-nav');
const mobileClose=qs('#mobile-nav-close');
function openMobileNav(){
  menuToggle?.setAttribute('aria-expanded','true');
  menuToggle?.classList.add('open');
  mobileNav?.classList.add('open');
  mobileNav?.setAttribute('aria-hidden','false');
  showOverlay();
  document.body.style.overflow='hidden';
}
function closeMobileNav(){
  menuToggle?.setAttribute('aria-expanded','false');
  menuToggle?.classList.remove('open');
  mobileNav?.classList.remove('open');
  mobileNav?.setAttribute('aria-hidden','true');
  hideOverlay();
  document.body.style.overflow='';
}
on(menuToggle,'click',openMobileNav);
on(mobileClose,'click',closeMobileNav);

/* ── SEARCH ── */
const searchToggle=qs('#search-toggle');
const searchOverlay=qs('#search-overlay');
const searchClose=qs('#search-close');
const searchInput=qs('#search-input');
function openSearch(){
  searchOverlay?.classList.add('open');
  searchOverlay?.setAttribute('aria-hidden','false');
  searchToggle?.setAttribute('aria-expanded','true');
  setTimeout(()=>searchInput?.focus(),100);
}
function closeSearch(){
  searchOverlay?.classList.remove('open');
  searchOverlay?.setAttribute('aria-hidden','true');
  searchToggle?.setAttribute('aria-expanded','false');
}
on(searchToggle,'click',openSearch);
on(searchClose,'click',closeSearch);
on(document,'keydown',e=>{if(e.key==='Escape'){closeSearch();closeMobileNav();closeCart();}});

/* ── CART DRAWER ── */
const cartTrigger=qs('#cart-trigger');
const cartDrawer=qs('#cart-drawer');
const cartClose=qs('#cart-close');
const cartOverlay=qs('#cart-overlay');
const cartBadge=qs('.cart-badge');
const cartDrawerBody=qs('#cart-drawer-body');
const cartDrawerFooter=qs('#cart-drawer-footer');

function openCart(){
  cartDrawer?.classList.add('open');
  cartDrawer?.setAttribute('aria-hidden','false');
  cartOverlay?.classList.add('open');
  document.body.style.overflow='hidden';
}
function closeCart(){
  cartDrawer?.classList.remove('open');
  cartDrawer?.setAttribute('aria-hidden','true');
  cartOverlay?.classList.remove('open');
  document.body.style.overflow='';
}
on(cartTrigger,'click',openCart);
on(cartClose,'click',closeCart);
on(cartOverlay,'click',closeCart);
on(overlay,'click',()=>{closeMobileNav();closeSearch();});

/* ── CART API ── */
async function fetchCart(){
  const r=await fetch('/cart.js');
  return r.json();
}
async function updateCartUI(cart){
  if(!cart)cart=await fetchCart();
  const count=cart.item_count;
  // Badge
  if(cartBadge){
    cartBadge.textContent=count;
    cartBadge.classList.toggle('hidden',count===0);
    if(count>0){cartBadge.classList.add('bump');setTimeout(()=>cartBadge.classList.remove('bump'),400);}
  }
  // Drawer title count
  const drawerCount=qs('.cart-drawer__count');
  if(drawerCount)drawerCount.textContent='('+count+')';
  // Drawer body
  if(cartDrawerBody){
    if(count===0){
      cartDrawerBody.innerHTML='<div class="cart-empty"><p>Your bag is empty.</p><a href="/collections/all" class="btn btn-solid">Shop now</a></div>';
    } else {
      cartDrawerBody.innerHTML=cart.items.map(item=>`
        <div class="cart-item" data-key="${item.key}">
          <a href="${item.url}" class="cart-item__img">
            <img src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">
          </a>
          <div class="cart-item__info">
            <a href="${item.url}" class="cart-item__name">${item.product_title}</a>
            ${item.variant_title&&item.variant_title!=='Default Title'?`<p class="cart-item__variant">${item.variant_title}</p>`:''}
            <div class="cart-item__bottom">
              <div class="cart-item__qty">
                <button class="qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease">−</button>
                <span class="qty-val">${item.quantity}</span>
                <button class="qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase">+</button>
              </div>
              <span class="cart-item__price">${money(item.line_price)}</span>
            </div>
          </div>
          <button class="cart-item__remove" data-key="${item.key}" aria-label="Remove">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
          </button>
        </div>
      `).join('');
    }
  }
  // Footer
  if(cartDrawerFooter){
    if(count===0){
      cartDrawerFooter.innerHTML='';
    } else {
      cartDrawerFooter.innerHTML=`
        <div class="cart-subtotal">
          <span>Subtotal</span>
          <span class="cart-subtotal__price">${money(cart.total_price)}</span>
        </div>
        <a href="/checkout" class="btn btn-solid btn-full">Checkout</a>
        <a href="/cart" class="btn btn-ghost btn-full">View bag</a>
      `;
    }
  }
  // Rebind qty/remove buttons
  bindCartButtons();
}

function bindCartButtons(){
  qsa('.qty-btn').forEach(btn=>{
    on(btn,'click',async function(){
      const key=this.dataset.key;
      const action=this.dataset.action;
      const val=qs(`.cart-item[data-key="${key}"] .qty-val`);
      const cur=+(val?.textContent||1);
      const next=action==='increase'?cur+1:Math.max(0,cur-1);
      try{
        const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:next})});
        const cart=await r.json();
        await updateCartUI(cart);
      }catch(e){console.error(e);}
    });
  });
  qsa('.cart-item__remove').forEach(btn=>{
    on(btn,'click',async function(){
      const key=this.dataset.key;
      try{
        const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})});
        const cart=await r.json();
        await updateCartUI(cart);
      }catch(e){console.error(e);}
    });
  });
}

// Init cart
fetchCart().then(updateCartUI);
bindCartButtons();

/* ── ADD TO BAG ── */
on(document,'click',async function(e){
  const btn=e.target.closest('.add-to-bag');
  if(!btn)return;
  const id=btn.dataset.variantId;
  if(!id)return;
  const orig=btn.textContent;
  btn.disabled=true;
  btn.innerHTML='<span class="loading-spinner"></span>';
  try{
    const r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:parseInt(id),quantity:1})
    });
    if(r.ok){
      const cart=await fetchCart();
      await updateCartUI(cart);
      btn.textContent='Added ✓';
      setTimeout(()=>{btn.textContent=orig;btn.disabled=false;openCart();},800);
    } else {
      const err=await r.json();
      btn.textContent=err.description||'Error';
      setTimeout(()=>{btn.textContent=orig;btn.disabled=false;},2000);
    }
  }catch(e){
    btn.textContent=orig;btn.disabled=false;
  }
});

on(document,'click',async function(e){
  const btn=e.target.closest('.add-starter-set');
  if(!btn)return;
  const ids=(btn.dataset.variantIds||'').split(',').map(id=>parseInt(id,10)).filter(Boolean);
  if(!ids.length)return;
  const orig=btn.textContent;
  btn.disabled=true;
  btn.innerHTML='<span class="loading-spinner"></span>';
  try{
    const r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:ids.map(id=>({id,quantity:1}))})
    });
    if(r.ok){
      const cart=await fetchCart();
      await updateCartUI(cart);
      btn.textContent='Added ✓';
      setTimeout(()=>{btn.textContent=orig;btn.disabled=false;openCart();},800);
    } else {
      btn.textContent='Error';
      setTimeout(()=>{btn.textContent=orig;btn.disabled=false;},2000);
    }
  }catch(e){
    btn.textContent=orig;btn.disabled=false;
  }
});

/* ── VARIANT SELECTION ── */
on(document,'click',function(e){
  const opt=e.target.closest('.variant-opt');
  if(!opt||opt.classList.contains('sold-out'))return;
  qsa('.variant-opt',opt.closest('.variant-opts')).forEach(o=>o.classList.remove('active'));
  opt.classList.add('active');
  if(opt.dataset.variantId){
    qsa('.add-to-bag').forEach(btn=>btn.dataset.variantId=opt.dataset.variantId);
  }
  // Update price display
  if(opt.dataset.price){
    const priceEl=qs('.product-info__price');
    if(priceEl)priceEl.textContent=money(+opt.dataset.price);
  }
});

/* ── PRODUCT GALLERY ── */
on(document,'click',function(e){
  const thumb=e.target.closest('.product-media__thumb');
  if(!thumb)return;
  const src=thumb.dataset.src;
  if(!src)return;
  const main=qs('#main-product-image')||qs('.product-media__main img');
  if(main){
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src=src;
    const thumbImg=qs('img',thumb);
    if(thumbImg&&thumbImg.alt)main.alt=thumbImg.alt;
  }
  qsa('.product-media__thumb').forEach(t=>t.classList.remove('active'));
  thumb.classList.add('active');
});

})();
// Announcement slider
(function(){
  const bar = document.querySelector('.announcement-bar__inner');
  if(!bar) return;
  const parts = bar.textContent.trim().split('·').map(s=>s.trim()).filter(Boolean);
  if(parts.length < 2) return;
  bar.innerHTML = parts.map((t,i)=>
    `<div style="
      position:absolute;inset:0;display:flex;align-items:center;justify-content:center;
      font-size:13px;letter-spacing:.2em;font-family:var(--body);font-weight:500;
      opacity:${i===0?1:0};transform:translateY(${i===0?0:10}px);
      transition:opacity .6s ease,transform .6s ease;white-space:nowrap;
    ">${t}</div>`
  ).join('');
  bar.style.cssText='position:relative;height:40px;overflow:hidden';
  const divs=bar.querySelectorAll('div');
  let cur=0;
  setInterval(()=>{
    divs[cur].style.opacity='0';
    divs[cur].style.transform='translateY(-10px)';
    cur=(cur+1)%divs.length;
    divs[cur].style.opacity='1';
    divs[cur].style.transform='translateY(0)';
  },3000);
})();
